import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from 'hisng';

@Injectable()
export class RightsService {

    constructor( private backendService: HisBackendService ) { }

    public hasRightsOnObject( objectId: number, objectName: string, rightsArray: string[] ): Observable<boolean> {
        objectName = objectName.charAt(0).toUpperCase() + objectName.slice(1);
        return this.backendService.postData( `api/v1/fs/res/hasRightsOnObject/${objectName}/${objectId}/true`, rightsArray );
    }

}
